import type { JSX } from '@builder.io/qwik';
import { component$, useSignal, useVisibleTask$ } from '@builder.io/qwik';
import type { TwitterBlockAttsInterface } from '~/types/AppData/Blocks/TwitterBlockInterface';
import { cva } from 'class-variance-authority';
import { useIsPremiumTemplate } from '~/utilities/useIsPremiumTemplate';

const cssClasses = cva('min-h-[550px]', {
  variants: {
    isPremium: {
      true: 'flex justify-center',
    },
  },
});

export default component$(
  ({ mediaId }: TwitterBlockAttsInterface): JSX.Element => {
    const containerRef = useSignal<HTMLDivElement>();
    const isPremium = useIsPremiumTemplate();
    const heightSignal = useSignal<number>(550);

    useVisibleTask$(({ track }) => {
      if (typeof window === 'undefined') return;
      track(() => containerRef.value);
      // Load Twitter script if not already loaded
      if (!window.mmTwitterLoaded) {
        window.mmTwitterLoaded = true;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://platform.twitter.com/widgets.js';
        document.body.appendChild(script);
      }
      // Poll for twttr.widgets and containerRef
      const tryRender = () => {
        if (window.twttr && window.twttr.widgets && containerRef.value) {
          window.twttr.widgets
            .createTweet(mediaId, containerRef.value)
            .then((el: HTMLElement | undefined) => {
              if (el) {
                heightSignal.value = el.offsetHeight;
              }
            })
            .catch((err: unknown) => {
              console.error('Twitter embed error:', err);
            });
        } else {
          setTimeout(tryRender, 200);
        }
      };
      tryRender();
    });

    return (
      <figure
        class={cssClasses({ isPremium })}
        style={{ minHeight: `${heightSignal.value}px` }}
      >
        <div ref={containerRef}></div>
      </figure>
    );
  }
);
